import {
  CompanyOrganisationTranslationKeys,
  CustomMenuItem,
  CVTekModuleTranlationKeys,
  JobModuleTranslationKeys,
  RoutesValues,
  TranslateKey,
  TranslateRoutesKey,
} from '@job-v2/ats-utils';
import { ADMIN_ROLES, ALL_ROLES } from '@socium/sociumflow';
import { 
  JOB_CONFIGURATIONS_ACCESS, 
  JOB_CUSTOMIZE_COMPANY_PRESENTATION, 
  JOB_MANAGE_MAILING_LISTS, 
  JOB_MANAGE_COMPANY_SETTINGS, 
  JOB_OFFERS_ACCESS, 
  JOB_TEMPLATES_ACCESS, 
  JOB_TEMPLATES_CONFIGURE_PIPELINES, 
  JOB_TEMPLATES_DEFINE_SELECTION_CRITERIA, 
  JOB_TEMPLATES_MANAGE_RECRUITMENT_REPORTS, 
  JOB_TEMPLATES_MANAGE_EMAIL_TEMPLATES, 
  JOB_TEMPLATES_MANAGE_OFFER_TEMPLATES, 
  JOB_TEMPLATES_MANAGE_PRE_QUALIFICATION,
  JOB_DASHBOARD_ACCESS
} from '@socium/common-api';

export const dashboardMenu: CustomMenuItem[] = [
  {
    label: JobModuleTranslationKeys.DASHBOARD,
    items: [
      {
        label: JobModuleTranslationKeys.DASHBOARD,
        icon: 'uil uil-tachometer-fast-alt text-xl',
        routerLink: ['dashboard'],
        roles: ALL_ROLES,
      },
    ],
    canPermission: JOB_DASHBOARD_ACCESS,
  },
];

export const managementMenu: CustomMenuItem[] = [
  {
    label: TranslateKey.MANAGEMENT,
    items: [
      {
        label: JobModuleTranslationKeys.SECTION_TITLE,
        icon: 'uil uil-briefcase',
        routerLink: [`${RoutesValues.MANAGEMENT}/jobs`],
        roles: ALL_ROLES,
        canPermission: JOB_OFFERS_ACCESS,
      },
      {
        label: CVTekModuleTranlationKeys.SECTION_TITLE,
        icon: 'uil uil-save',
        routerLink: [`${RoutesValues.MANAGEMENT}/cv-tek`],
        roles: ALL_ROLES,
        canPermission: JOB_OFFERS_ACCESS,
      },
    ],
    roles: ALL_ROLES,
    canPermission: JOB_OFFERS_ACCESS,
  },
];

export const ModelsMenu: CustomMenuItem[] = [
  {
    label: TranslateRoutesKey.MODELS_SECTION_ROUTE_LABEL,
    items: [
      {
        label: TranslateRoutesKey.MODELS_JOBS_ROUTE_LABEL,
        icon: 'uil uil-briefcase',
        routerLink: [`${RoutesValues.MODELS}/job`],
        roles: ALL_ROLES,
        canPermission: JOB_TEMPLATES_MANAGE_OFFER_TEMPLATES,
      },
      {
        label: TranslateRoutesKey.MODELS_PRE_QUALIFICATIONS,
        icon: 'uil uil-apps',
        routerLink: '/models/pre_qualification',
        roles: ALL_ROLES,
        canPermission: JOB_TEMPLATES_MANAGE_PRE_QUALIFICATION,
      },
      {
        label: TranslateRoutesKey.MODELS_EMAILS_ROUTE_LABEL,
        icon: 'uil uil-envelope-alt',
        routerLink: [`${RoutesValues.MODELS}/email`],
        roles: ALL_ROLES,
        canPermission: JOB_TEMPLATES_MANAGE_EMAIL_TEMPLATES,
      },
      {
        label: TranslateRoutesKey.MODELS_PIPELINES_ROUTE_LABEL,
        icon: 'uil uil-briefcase',
        routerLink: [`${RoutesValues.MODELS}/pipeline`],
        roles: ALL_ROLES,
        canPermission: JOB_TEMPLATES_CONFIGURE_PIPELINES,
      },
      {
        label: TranslateRoutesKey.MODELS_RR_ROUTE_LABEL,
        icon: 'uil uil-file-graph',
        routerLink: [`${RoutesValues.MODELS}/recruitment_report`],
        roles: ALL_ROLES,
        canPermission: JOB_TEMPLATES_MANAGE_RECRUITMENT_REPORTS,
      },
      {
        label: TranslateRoutesKey.MODELS_CRITERIA_ROUTE_LABEL,
        icon: 'uil uil-apps',
        routerLink: '/models/criteria-model',
        roles: ALL_ROLES,
        canPermission: JOB_TEMPLATES_DEFINE_SELECTION_CRITERIA,
      },
    ],
    roles: ALL_ROLES,
    canPermission: JOB_TEMPLATES_ACCESS,
  },
];

export const settingsMenu: CustomMenuItem[] = [
  {
    label: TranslateKey.SETTINGS,
    items: [
      {
        label: CompanyOrganisationTranslationKeys.TITLE,
        icon: 'uil uil-presentation',
        routerLink: [`${RoutesValues.SETTINGS}/company-details`],
        roles: ADMIN_ROLES,
        canPermission: JOB_MANAGE_COMPANY_SETTINGS,
      },
      {
        label: TranslateKey.COMPANY_PRESENTATION,
        icon: 'uil uil-presentation',
        routerLink: [`${RoutesValues.SETTINGS}/presentation`],
        roles: ADMIN_ROLES,
        canPermission: JOB_CUSTOMIZE_COMPANY_PRESENTATION,
      },
      {
        label: TranslateKey.DIFFUSION_LIST_TITLE,
        icon: 'uil uil-envelope-bookmark',
        routerLink: [`${RoutesValues.SETTINGS}/diffusions-lists`],
        roles: ADMIN_ROLES,
        canPermission: JOB_MANAGE_MAILING_LISTS,
      },
    ],
    roles: ADMIN_ROLES,
    canPermission: JOB_CONFIGURATIONS_ACCESS,
  },
];

export const adminMenu: CustomMenuItem[] = [
  ...dashboardMenu,
  ...managementMenu,
  ...ModelsMenu,
  ...settingsMenu,
];

export const managerMenu: CustomMenuItem[] = [
  ...dashboardMenu,
  ...managementMenu,
  ...ModelsMenu
];

export const recruiterMenu: CustomMenuItem[] = [
  ...dashboardMenu,
  {
    label: TranslateKey.MANAGEMENT,
    items: [
      {
        label: JobModuleTranslationKeys.SECTION_TITLE,
        icon: 'uil uil-briefcase',
        routerLink: [`${RoutesValues.MANAGEMENT}/jobs`],
        roles: ALL_ROLES,
      },
    ],
    roles: ALL_ROLES,
    canPermission: JOB_OFFERS_ACCESS,
  }
];
